export const enUS = {
    cbt: require('./en-US/cbt.json'),
    cp: require('./en-US/cp.json'),
    programs: require('./en-US/programs.json'),
    translation: require('./en-US/translation.json'),
    auth: require('./en-US/auth.json'),
    dashboard: require('./en-US/dashboard.json'),
    user: require('./en-US/user.json'),
    validation: require('./en-US/validation.json'),
    providers: require('./en-US/providers.json'),
    shared: require('./en-US/shared.json'),
    goals: require('./en-US/goals.json'),
    retriage: require('./en-US/retriage.json'),
    onboarding: require('./en-US/onboarding.json'),
    videoSessions: require('./en-US/videoSessions.json'),
    admin: require('./en-US/admin.json'),
    assessments: require('./en-US/assessments.json'),
    intakeForms: require('./en-US/intakeForms.json'),
    dailyPause: require('./en-US/dailyPause.json'),
    insuranceForm: require('./en-US/insuranceForm.json'),
};

export const frCA = {
    cbt: require('./fr-CA/cbt.json'),
    cp: require('./fr-CA/cp.json'),
    programs: require('./fr-CA/programs.json'),
    translation: require('./fr-CA/translation.json'),
    auth: require('./fr-CA/auth.json'),
    dashboard: require('./fr-CA/dashboard.json'),
    user: require('./fr-CA/user.json'),
    validation: require('./fr-CA/validation.json'),
    providers: require('./fr-CA/providers.json'),
    shared: require('./fr-CA/shared.json'),
    goals: require('./fr-CA/goals.json'),
    retriage: require('./fr-CA/retriage.json'),
    onboarding: require('./fr-CA/onboarding.json'),
    videoSessions: require('./fr-CA/videoSessions.json'),
    admin: require('./fr-CA/admin.json'),
    assessments: require('./fr-CA/assessments.json'),
    intakeForms: require('./fr-CA/intakeForms.json'),
    dailyPause: require('./fr-CA/dailyPause.json'),
    insuranceForm: require('./fr-CA/insuranceForm.json'),
};

export const frFR = {
    cbt: require('./fr-FR/cbt.json'),
    cp: require('./fr-FR/cp.json'),
    programs: require('./fr-FR/programs.json'),
    translation: require('./fr-FR/translation.json'),
    auth: require('./fr-FR/auth.json'),
    dashboard: require('./fr-FR/dashboard.json'),
    user: require('./fr-FR/user.json'),
    validation: require('./fr-FR/validation.json'),
    providers: require('./fr-FR/providers.json'),
    shared: require('./fr-FR/shared.json'),
    goals: require('./fr-FR/goals.json'),
    retriage: require('./fr-FR/retriage.json'),
    onboarding: require('./fr-FR/onboarding.json'),
    videoSessions: require('./fr-FR/videoSessions.json'),
    admin: require('./fr-FR/admin.json'),
    assessments: require('./fr-FR/assessments.json'),
    intakeForms: require('./fr-FR/intakeForms.json'),
    dailyPause: require('./fr-FR/dailyPause.json'),
    insuranceForm: require('./fr-FR/insuranceForm.json'),
};

export const jaJP = {
    cbt: require('./ja-JP/cbt.json'),
    cp: require('./ja-JP/cp.json'),
    programs: require('./ja-JP/programs.json'),
    translation: require('./ja-JP/translation.json'),
    auth: require('./ja-JP/auth.json'),
    dashboard: require('./ja-JP/dashboard.json'),
    user: require('./ja-JP/user.json'),
    validation: require('./ja-JP/validation.json'),
    providers: require('./ja-JP/providers.json'),
    shared: require('./ja-JP/shared.json'),
    goals: require('./ja-JP/goals.json'),
    retriage: require('./ja-JP/retriage.json'),
    onboarding: require('./ja-JP/onboarding.json'),
    videoSessions: require('./ja-JP/videoSessions.json'),
    admin: require('./ja-JP/admin.json'),
    assessments: require('./ja-JP/assessments.json'),
    intakeForms: require('./ja-JP/intakeForms.json'),
    dailyPause: require('./ja-JP/dailyPause.json'),
    insuranceForm: require('./ja-JP/insuranceForm.json'),
};

export const koKR = {
    cbt: require('./ko-KR/cbt.json'),
    cp: require('./ko-KR/cp.json'),
    programs: require('./ko-KR/programs.json'),
    translation: require('./ko-KR/translation.json'),
    auth: require('./ko-KR/auth.json'),
    dashboard: require('./ko-KR/dashboard.json'),
    user: require('./ko-KR/user.json'),
    validation: require('./ko-KR/validation.json'),
    providers: require('./ko-KR/providers.json'),
    shared: require('./ko-KR/shared.json'),
    goals: require('./ko-KR/goals.json'),
    retriage: require('./ko-KR/retriage.json'),
    onboarding: require('./ko-KR/onboarding.json'),
    videoSessions: require('./ko-KR/videoSessions.json'),
    admin: require('./ko-KR/admin.json'),
    assessments: require('./ko-KR/assessments.json'),
    intakeForms: require('./ko-KR/intakeForms.json'),
    dailyPause: require('./ko-KR/dailyPause.json'),
    insuranceForm: require('./ko-KR/insuranceForm.json'),
};

export const esLA = {
    cbt: require('./es-LA/cbt.json'),
    cp: require('./es-LA/cp.json'),
    programs: require('./es-LA/programs.json'),
    translation: require('./es-LA/translation.json'),
    auth: require('./es-LA/auth.json'),
    dashboard: require('./es-LA/dashboard.json'),
    user: require('./es-LA/user.json'),
    validation: require('./es-LA/validation.json'),
    providers: require('./es-LA/providers.json'),
    shared: require('./es-LA/shared.json'),
    goals: require('./es-LA/goals.json'),
    retriage: require('./es-LA/retriage.json'),
    onboarding: require('./es-LA/onboarding.json'),
    videoSessions: require('./es-LA/videoSessions.json'),
    admin: require('./es-LA/admin.json'),
    assessments: require('./es-LA/assessments.json'),
    intakeForms: require('./es-LA/intakeForms.json'),
    dailyPause: require('./es-LA/dailyPause.json'),
    insuranceForm: require('./es-LA/insuranceForm.json'),
};

export const zhCN = {
    cbt: require('./zh-CN/cbt.json'),
    cp: require('./zh-CN/cp.json'),
    programs: require('./zh-CN/programs.json'),
    translation: require('./zh-CN/translation.json'),
    auth: require('./zh-CN/auth.json'),
    dashboard: require('./zh-CN/dashboard.json'),
    user: require('./zh-CN/user.json'),
    validation: require('./zh-CN/validation.json'),
    providers: require('./zh-CN/providers.json'),
    shared: require('./zh-CN/shared.json'),
    goals: require('./zh-CN/goals.json'),
    retriage: require('./zh-CN/retriage.json'),
    onboarding: require('./zh-CN/onboarding.json'),
    videoSessions: require('./zh-CN/videoSessions.json'),
    admin: require('./zh-CN/admin.json'),
    assessments: require('./zh-CN/assessments.json'),
    intakeForms: require('./zh-CN/intakeForms.json'),
    dailyPause: require('./zh-CN/dailyPause.json'),
    insuranceForm: require('./zh-CN/insuranceForm.json'),
};

export const deDE = {
    cbt: require('./de-DE/cbt.json'),
    cp: require('./de-DE/cp.json'),
    programs: require('./de-DE/programs.json'),
    translation: require('./de-DE/translation.json'),
    auth: require('./de-DE/auth.json'),
    dashboard: require('./de-DE/dashboard.json'),
    user: require('./de-DE/user.json'),
    validation: require('./de-DE/validation.json'),
    providers: require('./de-DE/providers.json'),
    shared: require('./de-DE/shared.json'),
    goals: require('./de-DE/goals.json'),
    retriage: require('./de-DE/retriage.json'),
    onboarding: require('./de-DE/onboarding.json'),
    videoSessions: require('./de-DE/videoSessions.json'),
    admin: require('./de-DE/admin.json'),
    assessments: require('./de-DE/assessments.json'),
    intakeForms: require('./de-DE/intakeForms.json'),
    dailyPause: require('./de-DE/dailyPause.json'),
    insuranceForm: require('./de-DE/insuranceForm.json'),
};

export const ptBR = {
    cbt: require('./pt-BR/cbt.json'),
    cp: require('./pt-BR/cp.json'),
    programs: require('./pt-BR/programs.json'),
    translation: require('./pt-BR/translation.json'),
    auth: require('./pt-BR/auth.json'),
    dashboard: require('./pt-BR/dashboard.json'),
    user: require('./pt-BR/user.json'),
    validation: require('./pt-BR/validation.json'),
    providers: require('./pt-BR/providers.json'),
    shared: require('./pt-BR/shared.json'),
    goals: require('./pt-BR/goals.json'),
    retriage: require('./pt-BR/retriage.json'),
    onboarding: require('./pt-BR/onboarding.json'),
    videoSessions: require('./pt-BR/videoSessions.json'),
    admin: require('./pt-BR/admin.json'),
    assessments: require('./pt-BR/assessments.json'),
    intakeForms: require('./pt-BR/intakeForms.json'),
    dailyPause: require('./pt-BR/dailyPause.json'),
    insuranceForm: require('./pt-BR/insuranceForm.json'),
};

export const hiIN = {
    cbt: require('./hi-IN/cbt.json'),
    cp: require('./hi-IN/cp.json'),
    programs: require('./hi-IN/programs.json'),
    translation: require('./hi-IN/translation.json'),
    auth: require('./hi-IN/auth.json'),
    dashboard: require('./hi-IN/dashboard.json'),
    user: require('./hi-IN/user.json'),
    validation: require('./hi-IN/validation.json'),
    providers: require('./hi-IN/providers.json'),
    shared: require('./hi-IN/shared.json'),
    goals: require('./hi-IN/goals.json'),
    retriage: require('./hi-IN/retriage.json'),
    onboarding: require('./hi-IN/onboarding.json'),
    videoSessions: require('./hi-IN/videoSessions.json'),
    admin: require('./hi-IN/admin.json'),
    assessments: require('./hi-IN/assessments.json'),
    intakeForms: require('./hi-IN/intakeForms.json'),
    dailyPause: require('./hi-IN/dailyPause.json'),
    insuranceForm: require('./hi-IN/insuranceForm.json'),
};
